import types from '../types/signup'
import {Map} from 'immutable'

const initialRoot = Map({
  open: false,
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.OPEN:
      return state.set('open', true)
    case types.CLOSE:
      return state.set('open', false)
    case '@@router/LOCATION_CHANGE':
      return state.set('open', false)
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/signup/reducers/signup.js